import * as React from "react";
import {
  ColumnDef,
  createColumnHelper,
  HeaderContext
} from "@tanstack/react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { SelectableDrop } from "src/pages/Admin/CustomersAndUsers/Customer/Users/UserDrops/CustomerUserAssignedDropsTab";

export interface IUserAssignableDropsTableColumn {
  checkboxAction: (data: SelectableDrop) => void
  bulkActionButton: (info: HeaderContext<SelectableDrop, unknown>) => React.ReactNode,
  terminology: ITerminology
  columns?: CustomerUserDropColumnsPicked[]
}

type CustomerUserDropColumnsPicked = keyof AvailableCustomerUserDropsTableColumns;

interface AvailableCustomerUserDropsTableColumns{
  branchNumber: ColumnDef<SelectableDrop, unknown>;
  branchName: ColumnDef<SelectableDrop, unknown>;
  branchType: ColumnDef<SelectableDrop, unknown>;
  bulkActionCheck: ColumnDef<SelectableDrop, unknown>;
}
/**
 * takes in a bulk action button and check box on change handler
 * returns columns that show a checkbox, branch number, branch name and branch type.
 */
export const getUserAssignableDropsTableColumns = (params: IUserAssignableDropsTableColumn) => {
  const customDropColumnHelper = customCreateColumnHelper<SelectableDrop>();
  const dropColumnHelper = createColumnHelper<SelectableDrop>();

  const AllColumns: AvailableCustomerUserDropsTableColumns = {
    bulkActionCheck: customDropColumnHelper.checkboxColumn(dropColumnHelper, {
      enableColumnFilter: false,
      enableSorting: false
    }, "selected", params.checkboxAction, params.bulkActionButton),

    branchNumber: customDropColumnHelper.standardTextColumn(dropColumnHelper, "branchNumber", {
      header: "Delivery Point Number",
      size: 200
    }),
    branchName: customDropColumnHelper.standardTextColumn(dropColumnHelper, "name", { header: "name" }),
    branchType: customDropColumnHelper.standardTextColumn(dropColumnHelper, "type", {
      header: "Type",
      meta: {
        filter: {
          filterType: "select",
          options: [
            {
              value: "standard",
              text: "standard"
            },
            {
              value: "bulk",
              text: "bulk"
            }
          ]
        }
      }
    })

  };

  if (params.columns) {
    return params.columns.map(column => AllColumns[ column ]);
  } else {
    return Object.values(AllColumns);
  }
};
